export const Course ={
    
	NotStarted: {
		k: "completion.NotStarted",
		v: "Not Started"
	},

	Started: {
		k: "completion.Started",
		v: "Started"
	},

	Incomplete: {
		k: "completion.Incomplete",
		v: "Incomplete"
	},

	Completed: {
		k: "completion.Completed",
		v: "Completed"
	},

	Passed: {
		k: "completion.Passed",
		v: "Passed"
	},

	Failed: {
		k: "completion.Failed",
		v: "Failed"
	},

	Launch: {
		k: "link.launch",
		v: "Launch"
	},

	View: {
		k: "link.view",
		v: "View"
	},

	Buy: {
		k: "link.buy",
		v: "Buy Now"
	},
	Completion:{
        k: "refine.completion",
        v: "Completion"
    },
    CourseLaunch: {
		k:"course.launch",
		v: "Launch"
	},
	CourseView: {
		k:"course.view",
		v: "View"
	},
	CourseStatus: {
		k:"course.status",
		v: "Status"
	}

};


// WEBPACK FOOTER //
// ./src/common/Labels/Course.ts